import React from 'react'
import styled from '@emotion/styled'
import { fontSize2XSmall } from '../../constants/principles'
import TwoButtonModal from '../generic/modals/TwoButtonModal'
import { ModalContentNormal } from '../generic/Basics'
import { PaintMeterData } from './PaintMeterData'
import Textbox from '../generic/textboxWithRegex'
import RadioToggle from '../generic/toggles/radioToggle'
import { useStateValue } from '../../hooks'
import Error from '../generic/Error'
import Warning from '../generic/Warn'

export default ({ isDesktop, setShowModal, showModal, bodyStyle, paintMeterQuestions, saveQuestionResponseArray, getQuestionResponseArray }) => {
  const data = PaintMeterData.content.find(q => q.bodyStyle.includes(bodyStyle.toUpperCase())) || PaintMeterData.content.find(q => q.bodyStyle.includes('DEFAULT'))
  const [isError, setError] = useStateValue(false)
  const [isWarning, setWarning] = useStateValue(false)
  const [wasValidated, setWasValidated] = useStateValue(false)
  const [storedQuestionAndAnswers, setStoredQuestionAndAnswers] = useStateValue(getQuestionResponseArray('qmeter'))
  const [questionListAndAnswersLocal, setQuestionListAndAnswersLocal] = useStateValue(getQuestionListAndAnswersLocal())

  function getQuestionListAndAnswersLocal() {
    return (paintMeterQuestions ? paintMeterQuestions.items : [])
      .map(val => {
        let qVal = storedQuestionAndAnswers && storedQuestionAndAnswers.length && storedQuestionAndAnswers.find(q => q.questionId === val.questionId).value
        let q = { questionId: val.questionId, value: qVal, order: val.label.split('|')[0], label: val.label.replace('|', '. ') }
        return q
      })
      .sort((a, b) => a.order - b.order)
  }

  const updateLocal = (questionId, value) => {
    questionListAndAnswersLocal.find(q => q.questionId === questionId).value = !value ? undefined : value
    setError(false)
    setWasValidated(false)
  }

  const validateAnswers = () => {
    let notAnswered = questionListAndAnswersLocal.some(q => !q.value)
    let Answered = questionListAndAnswersLocal.some(q => q.value)
    if (notAnswered && Answered) {
      setError(true)
    } else {
      let allValuesAreEqual = questionListAndAnswersLocal.every(v => v.value === questionListAndAnswersLocal[0].value)
      setWarning(!allValuesAreEqual)
      saveQuestionResponseArray('qmeter', Answered ? questionListAndAnswersLocal.map(o => ({ questionId: o.questionId, value: o.value })) : [])
      setStoredQuestionAndAnswers(Answered ? questionListAndAnswersLocal.map(o => ({ questionId: o.questionId, value: o.value })) : [])
      setError(false)
      setShowModal(false)
      setWasValidated(true)
    }
  }

  const clearAllAnswers = () => {
    saveQuestionResponseArray('qmeter', [])
    setStoredQuestionAndAnswers([])
    setError(false)
    setWarning(false)
    questionListAndAnswersLocal.forEach(q => {
      updateLocal(q.questionId, undefined)
    })
    setWasValidated(true)
  }

  const cancelModal = () => {
    setQuestionListAndAnswersLocal(getQuestionListAndAnswersLocal()) // set back to orig
    setError(false)
    setShowModal(false)
    setWasValidated(true)
  }

  // In case they click outside of the modal and close it, we want it to function like cancel
  if (!showModal && !wasValidated) {
    cancelModal()
    setWasValidated(true)
  }

  return (
    <>
      <RadioToggle pills={['Yes', 'No']} selectedIndex={+questionListAndAnswersLocal.some(q => !q.value)} onClickItem={i => (i === 0 ? setShowModal('PaintMeterModal') : clearAllAnswers())} />
      <TwoButtonModal
        name={'PaintMeterModal'}
        positiveCopyOverride={'Done'}
        onClickPositive={e => validateAnswers()}
        onClickNegative={e => cancelModal()}
        title={'Paint Meter Readings'}
        subtitle={"Enter the vehicle's paint meter readings below to check for inconsistencies."}
        dependencyList={[isError]}>
        <ModalContentNormal>
          <ImageDiv>
            <img src={data.src} alt="Paint Meter Vehicle" height={isDesktop ? data.height + 'px' : data.height * 0.65 + 'px'} width={isDesktop ? data.width + 'px' : data.width * 0.65 + 'px'} />
          </ImageDiv>
          {isError && <Error isError={isError} id={'required-error'} text={'Please answer all questions.'} />}

          <AnswersDiv isDesktop={isDesktop}>
            {questionListAndAnswersLocal.map((q, i) => {
              return (
                <Textbox
                  id={q.questionId}
                  key={q.questionId}
                  regexPattern="^[1-9]{0,1}\d{0,1}(\.\d{0,2})?$"
                  inputMode={'decimal'}
                  value={q.value || ''}
                  label={q.label}
                  type={'text'}
                  height={'24px'}
                  width={'60px'}
                  margin={'4px'}
                  maxLength={5}
                  onBlur={newValue => updateLocal(q.questionId, newValue)}
                />
              )
            })}
          </AnswersDiv>
        </ModalContentNormal>
      </TwoButtonModal>
      {isWarning && (
        <Warning
          title={'Vehicle may have been repainted'}
          text={
            'The paint meter readings suggest this vehicle may have been repainted. Please check the vehicle closely for damage, and enter all damage on the vehicle questionnaire. Only the damage you enter into the vehicle questionnaire is taken into account in the calculation of your Instant Cash Offer.'
          }
        />
      )}
    </>
  )
}

const AnswersDiv = styled.div`
  padding: 8px;
  -moz-column-count: ${p => p.isDesktop && 2};
  -webkit-column-count: ${p => p.isDesktop && 2};
  column-count: ${p => p.isDesktop && 2};
  text-align: center;
  display: inline-block;
  font-size: ${fontSize2XSmall};
`
const ImageDiv = styled.div`
  padding-top: 16px;
`
